import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import ContactFormModal from "../Contacts/ContactFormModal";
import classNames from "classnames"

class ContactList extends Component {
  render() {
    const { editContact, action, newContact, contacts } = this.props
    return (
      <>
        <ContactFormModal />
        <div>

          <Table size="sm" responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Consent</th>
                <th>Notes</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                this.props.contacts.map((contact) => {
                  let contact_kind_list = contact.contact_kind_list || [];
                  return (
                    <tr
                      key={contact.id}
                      className={classNames({
                        "table-danger": contact_kind_list.length > 0 && contact_kind_list[0].toLowerCase() === "emergency"
                      })}>
                      <td>{contact.name}</td>
                      <td>{contact_kind_list}</td>
                      <td>{contact.phone}</td>
                      <td>{contact.email}</td>
                      <td>{contact.consent ? 'Yes' : 'No'}</td>
                      <td>{contact.notes}</td>
                      <td>
                        {
                          this.props.action === "edit" &&
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.editContact(contact);
                            }}>
                            Edit
                          </a>
                        }
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
          <div className="d-flex justify-content-center">
            {
              this.props.action === "edit" &&
              <Button
                variant="link"
                onClick={() => {
                  this.props.newContact();
                }}>
                Add Contact
              </Button>
            }
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isStaffApp: state.config.isStaffApp,
    contacts: state.contacts,
    action: state.ui.action
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newContact: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "contact" }
      })
    },
    editContact: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: {
          resourceName: "contact",
          resource
        }
      })
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactList);
